import React from 'react';
import { joinClasses } from '../../../../../../Utils/className.util';
import styles from './TextArea.module.scss';

export interface TextAreaProps {
	className?: string;
	rows?: number;
	value?: string;
	onChange?: React.ChangeEventHandler<HTMLTextAreaElement>;
	hasError?: boolean;
	disabled?: boolean;
	charactersLimit?: number;
}

const TextArea = React.forwardRef<HTMLTextAreaElement, TextAreaProps>(
	({
		className,
		rows = 3,
		onChange,
		value,
		hasError = false,
		disabled,
		charactersLimit,
	}: TextAreaProps) => (
		<textarea
			className={joinClasses([
				styles.textArea,
				className,
				hasError ? styles.invalid : undefined,
			])}
			rows={rows}
			value={value}
			onChange={onChange}
			disabled={disabled}
			maxLength={charactersLimit}
		/>
	),
);

export default TextArea;
